<form>
  <div class="d-flex flex-wrap gap-1 border mt-1 p-1 position-relative">

    <small class="text-muted fst-italic position-absolute bg-white px-1"
      style="font-size: .65rem; opacity: .7; top: -.55rem; right: .5rem;">Calculated per unit</small>


    <div class="uic-type-field">
      <label class="form-check-label" for="discType">Type</label>
      <select class="form-select form-select-sm" name="discountType" [(ngModel)]="discountType"
        (change)="calculateDiscount()" id="discType">
        <option value="" disabled>Select a Type</option>
        <option value="Net">Net</option>
        <option value="Percentage">Percentage</option>
      </select>
    </div>

    <div class="uic-other-field">
      <label class="form-check-label" for="discNumber">{{getDiscountTypeLabel()}}</label>
      <input type="number" class="form-control form-control-sm" name="discountValue" [(ngModel)]="discountValue"
        (input)="calculateDiscount()" />
    </div>

    <div class="uic-other-field">
      <label class="form-check-label">Disc. Amt</label>
      <input type="number" class="form-control form-control-sm" [formControl]="getFormControl('discount')" readonly />
    </div>

    <div class="uic-other-field">
      <label class="form-check-label">Final Price</label>
      <input type="number" class="form-control form-control-sm" name="totalAmount" [(ngModel)]="totalAmount" readonly />
    </div>

  </div>
</form>
